import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { BaseHttpService } from '../../../services/base-http.service';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TileService extends BaseHttpService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
  ) {
    super();
  }

  getTile(z: number, x: number, y: number): Observable<Blob> {
    const language = this.translateService.getCurrentLang();
    return this.applyHttpOperators(
      this.http.get(
        environment.backend_host + `/tile/${z}/${x}/${y}/${language}`,
        {
          responseType: 'blob',
        },
      ),
    );
  }
}
